module.exports = __webpack_public_path__ + "img/img_wushuju.32791a4b.png";